export const PlaceParticipantSelectedId = 'place-participant-selected-id';
